var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTransportAndUtilityPublicTransport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-2734.000000, -432.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Transport-and-Utility/Public-transport",
    transform: "translate(2734.000000, 432.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24,24 C25.104,24 26,24.896 26,26 C26,27.104 25.104,28 24,28 C22.896,28 22,27.104 22,26 C22,24.896 22.896,24 24,24 Z M6.5,24 C7.604,24 8.5,24.896 8.5,26 C8.5,27.104 7.604,28 6.5,28 C5.396,28 4.5,27.104 4.5,26 C4.5,24.896 5.396,24 6.5,24 Z M3.631,5 C4.504,5 5.339,5.361 5.937,5.999 L5.937,5.999 L5.938,6 L26,6 C29.313,6 32,8.687 32,12 L32,12 L32,24 L27.858,25 C27.412,23.277 25.861,22 24,22 C22.139,22 20.588,23.277 20.142,25 L20.142,25 L10.358,25 C9.913,23.277 8.362,22 6.5,22 C4.939,22 3.602,22.903 2.942,24.207 L2.942,24.207 L0,22 L0,5 Z M26,9 L24,9 L24,18 L29,18 L29,12 C29,10.343 27.657,9 26,9 L26,9 Z M22,9 L3,9 L3,13 C3,14.657 4.343,16 6,16 L6,16 L22,16 L22,9 Z",
    id: 68
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransportAndUtilityPublicTransport);
export default __webpack_public_path__ + "static/media/transport-and-utility-public-transport.251473ad.svg";
export { ForwardRef as ReactComponent };